export const messages = {
  en: {
    activitiesTypeManage: {
      search: {
        title: 'Search Conditions',
        typeCd: 'Type Code',
        typeName: 'Type Name',
        defaultShow: 'Mobile Display',
        all: 'All',
        yes: 'Yes',
        no: 'No'
      },
      list: {
        title: 'Information Categories'
      },
      table: {
        typeCd: 'Type Code',
        typeName: 'Type Name',
        typeDesc: 'Type Description',
        seq: 'Display Order',
        defaultShow: 'Mobile Display'
      },
      add: {
        title: 'Add Category',
        typeName: 'Type Name',
        typeNamePlaceholder: 'Required, please enter type name',
        typeDesc: 'Type Description',
        typeDescPlaceholder: 'Optional, please enter type description',
        seq: 'Display Order',
        seqPlaceholder: 'Required, please enter display order',
        defaultShow: 'Mobile Display',
        defaultShowPlaceholder: 'Required, please select mobile display',
        success: 'Add successfully',
        error: 'Add failed'
      },
      edit: {
        title: 'Edit Category',
        typeCd: 'Type Code',
        typeName: 'Type Name',
        typeNamePlaceholder: 'Required, please enter type name',
        typeDesc: 'Type Description',
        typeDescPlaceholder: 'Optional, please enter type description',
        seq: 'Display Order',
        seqPlaceholder: 'Required, please enter display order',
        defaultShow: 'Mobile Display',
        defaultShowPlaceholder: 'Required, please select mobile display',
        success: 'Edit successfully',
        error: 'Edit failed'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this category?',
        success: 'Delete successfully',
        error: 'Delete failed'
      },
      validate: {
        typeCdRequired: 'Type code is required',
        typeNameRequired: 'Type name is required',
        typeNameMaxLength: 'Type name cannot exceed 100 characters',
        typeDescMaxLength: 'Type description cannot exceed 500 characters',
        seqRequired: 'Display order is required',
        seqNumber: 'Display order must be a number',
        defaultShowRequired: 'Mobile display is required'
      },
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    activitiesTypeManage: {
      search: {
        title: '查询条件',
        typeCd: '大类编码',
        typeName: '大类名称',
        defaultShow: '手机显示',
        all: '全部',
        yes: '是',
        no: '否'
      },
      list: {
        title: '信息大类'
      },
      table: {
        typeCd: '大类编码',
        typeName: '大类名称',
        typeDesc: '大类描述',
        seq: '显示序号',
        defaultShow: '手机显示'
      },
      add: {
        title: '添加大类',
        typeName: '大类名称',
        typeNamePlaceholder: '必填，请填写大类名称',
        typeDesc: '大类描述',
        typeDescPlaceholder: '选填，请填写大类描述',
        seq: '显示序号',
        seqPlaceholder: '必填，请填写显示序号',
        defaultShow: '手机显示',
        defaultShowPlaceholder: '必填，请选择是否手机显示',
        success: '添加成功',
        error: '添加失败'
      },
      edit: {
        title: '修改大类',
        typeCd: '大类编码',
        typeName: '大类名称',
        typeNamePlaceholder: '必填，请填写大类名称',
        typeDesc: '大类描述',
        typeDescPlaceholder: '选填，请填写大类描述',
        seq: '显示序号',
        seqPlaceholder: '必填，请填写显示序号',
        defaultShow: '手机显示',
        defaultShowPlaceholder: '必填，请选择是否显示',
        success: '修改成功',
        error: '修改失败'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除信息大类？',
        success: '删除成功',
        error: '删除失败'
      },
      validate: {
        typeCdRequired: '大类编码不能为空',
        typeNameRequired: '大类名称不能为空',
        typeNameMaxLength: '大类名称超过100位',
        typeDescMaxLength: '描述超过500位',
        seqRequired: '显示序号不能为空',
        seqNumber: '显示序号不是有效数字',
        defaultShowRequired: '是否显示不能为空'
      },
fetchError: '获取数据失败'
    }
  },
  'zh-TW': {
    activitiesTypeManage: {
      search: {
        title: '查詢條件',
        typeCd: '大類編碼',
        typeName: '大類名稱',
        defaultShow: '手機顯示',
        all: '全部',
        yes: '是',
        no: '否'
      },
      list: {
        title: '信息大類'
      },
      table: {
        typeCd: '大類編碼',
        typeName: '大類名稱',
        typeDesc: '大類描述',
        seq: '顯示序號',
        defaultShow: '手機顯示'
      },
      add: {
        title: '添加大類',
        typeName: '大類名稱',
        typeNamePlaceholder: '必填，請填寫大類名稱',
        typeDesc: '大類描述',
        typeDescPlaceholder: '選填，請填寫大類描述',
        seq: '顯示序號',
        seqPlaceholder: '必填，請填寫顯示序號',
        defaultShow: '手機顯示',
        defaultShowPlaceholder: '必填，請選擇是否手機顯示',
        success: '添加成功',
        error: '添加失敗'
      },
      edit: {
        title: '修改大類',
        typeCd: '大類編碼',
        typeName: '大類名稱',
        typeNamePlaceholder: '必填，請填寫大類名稱',
        typeDesc: '大類描述',
        typeDescPlaceholder: '選填，請填寫大類描述',
        seq: '顯示序號',
        seqPlaceholder: '必填，請填寫顯示序號',
        defaultShow: '手機顯示',
        defaultShowPlaceholder: '必填，請選擇是否顯示',
        success: '修改成功',
        error: '修改失敗'
      },
      delete: {
        title: '刪除確認',
        confirm: '確定刪除信息大類？',
        success: '刪除成功',
        error: '刪除失敗'
      },
      validate: {
        typeCdRequired: '大類編碼不能為空',
        typeNameRequired: '大類名稱不能為空',
        typeNameMaxLength: '大類名稱超過100位',
        typeDescMaxLength: '描述超過500位',
        seqRequired: '顯示序號不能為空',
        seqNumber: '顯示序號不是有效數字',
        defaultShowRequired: '是否顯示不能為空'
      },
      fetchError: '獲取數據失敗'
    }
  }
}